// Fix pour le cart drawer et les boutons add to cart
document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart fix loaded');
  
  // Fonction pour ouvrir le cart drawer
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      console.error('Cart drawer not found or open method not available');
    }
  }

  // Fonction pour mettre à jour le cart drawer
  function updateCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.updateCart === 'function') {
      cartDrawer.updateCart();
    }
  }

  // Intercepter les soumissions de formulaire add to cart
  document.addEventListener('submit', function(event) {
    const form = event.target;
    
    // Vérifier si c'est un formulaire add to cart
    if (form.getAttribute('data-type') === 'add-to-cart-form') {
      event.preventDefault();
      
      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }

      // Créer FormData
      const formData = new FormData(form);
      
      // Ajouter les paramètres nécessaires pour le cart drawer
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      // Faire la requête AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        
        // Mettre à jour le cart drawer avec les sections
        fetch('/?sections=cart-drawer&sections_url=' + encodeURIComponent(window.location.pathname))
          .then(response => response.json())
          .then(sections => {
            if (sections['cart-drawer']) {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
                const newCartDrawer = doc.querySelector('cart-drawer');
                if (newCartDrawer) {
                  cartDrawer.innerHTML = newCartDrawer.innerHTML;
                }
              }
            }
            
            // Ouvrir le cart drawer
            openCartDrawer();
          })
          .catch(error => {
            console.error('Error updating cart drawer:', error);
            // Ouvrir quand même le cart drawer
            openCartDrawer();
          });
        
        // Réactiver le bouton
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Réactiver le bouton en cas d'erreur
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
      });
    }
  });

  // Gérer les clics sur les boutons add to cart secondaires
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-skip-cart-button]');
    if (button) {
      event.preventDefault();
      
      // Trouver le formulaire principal
      const mainForm = document.querySelector('product-form[data-main="true"]');
      if (mainForm) {
        const form = mainForm.querySelector('form');
        if (form) {
          // Déclencher la soumission du formulaire principal
          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(submitEvent);
        }
      }
    }
  });

  // S'assurer que le cart drawer est initialisé correctement
  function initCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Ajouter des méthodes si elles n'existent pas
      if (!cartDrawer.open) {
        cartDrawer.open = function() {
          this.classList.add('active');
          document.body.classList.add('overflow-hidden');
        };
      }
      
      if (!cartDrawer.close) {
        cartDrawer.close = function() {
          this.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        };
      }
      
      if (!cartDrawer.updateCart) {
        cartDrawer.updateCart = function() {
          // Mettre à jour le contenu du cart drawer
          fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartDrawer = doc.querySelector('cart-drawer');
              if (newCartDrawer) {
                this.innerHTML = newCartDrawer.innerHTML;
              }
            })
            .catch(error => {
              console.error('Error updating cart drawer:', error);
            });
        };
      }
    }
  }

  // Initialiser le cart drawer
  initCartDrawer();
  
  // Réinitialiser après les mises à jour de sections Shopify
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('cart-drawer')) {
        initCartDrawer();
      }
    });
  }
}); 